module.exports = __webpack_public_path__ + "img/usa-flag.d3e4a47d.svg";